// GENERATED by scripts/generate-api-client.ts. Do not edit by hand.
//
// `P0-UIK-012`. Run `pnpm codegen:api-client` after changing the OpenAPI
// document; `generate-api-client.spec.ts` fails the build if this file drifts
// from it, so a hand edit is reverted by the generator rather than argued with.
//
// Typed over PATHS and METHODS only: the document is an inventory with empty
// operation objects, so there are no body types to emit. `P0-INF-026` adds the
// schemas, and this file gets richer without the pipeline changing. Emitting a
// body type the server never promised would let a screen compile against a
// fiction, which is worse than having none.

export const OPERATIONS = [
  { path: "/health", method: "get" },
  { path: "/ready", method: "get" },
  { path: "/version", method: "get" },
  { path: "/api/v1/openapi.json", method: "get" },
  { path: "/api/v1/operations", method: "get" },
  { path: "/api/v1/operations", method: "post" },
  { path: "/api/v1/operations/{id}", method: "get" },
  { path: "/api/v1/platform/conformance", method: "post" },
  { path: "/api/v1/platform/conformance/{id}", method: "get" },
  { path: "/api/v1/platform/conformance/{id}", method: "put" },
  { path: "/api/v1/platform/conformance/{id}", method: "patch" },
  { path: "/api/v1/platform/conformance/{id}/seal", method: "post" },
  { path: "/api/v1/platform/conformance/{id}/scoped", method: "get" },
  { path: "/api/v1/admin/outbox", method: "get" },
  { path: "/api/v1/admin/outbox/dead", method: "get" },
  { path: "/api/v1/admin/outbox/dead/{id}/replay", method: "post" },
  { path: "/api/v1/admin/outbox/dead/replay", method: "post" },
  { path: "/api/v1/banks", method: "get" },
  { path: "/api/v1/banks", method: "post" },
  { path: "/api/v1/banks/{id}", method: "get" },
  { path: "/api/v1/banks/{id}/criteria", method: "put" },
  { path: "/api/v1/banks/{id}/prefilter", method: "put" },
  { path: "/api/v1/banks/{id}/panel", method: "put" },
  { path: "/api/v1/banks/{id}/convention", method: "put" },
  { path: "/api/v1/bank/policy", method: "get" },
  { path: "/api/v1/bank/policy", method: "put" },
  { path: "/api/v1/bank/team", method: "get" },
  { path: "/api/v1/bank/pipeline", method: "get" },
  { path: "/api/v1/bank/files", method: "get" },
  { path: "/api/v1/bank/files/{id}", method: "get" },
  { path: "/api/v1/bank/files/{id}/rapport", method: "get" },
  { path: "/api/v1/bank/files/{id}/review", method: "post" },
  { path: "/api/v1/bank/files/{id}/review/{pointId}", method: "put" },
  { path: "/api/v1/bank/files/{id}/review/complete", method: "post" },
  { path: "/api/v1/bank/files/{id}/offer", method: "get" },
  { path: "/api/v1/bank/files/{id}/offer", method: "put" },
  { path: "/api/v1/bank/files/{id}/offer/submit", method: "post" },
  { path: "/api/v1/bank/files/{id}/offer/validate-and-send", method: "post" },
  { path: "/api/v1/bank/files/{id}/offer/send-to-committee", method: "post" },
  { path: "/api/v1/bank/files/{id}/underwriting", method: "get" },
  { path: "/api/v1/me/dealership/dossiers", method: "get" },
  { path: "/api/v1/me/dealership/dossiers", method: "post" },
  { path: "/api/v1/me/dealership/dossiers/{id}/pieces", method: "get" },
  { path: "/api/v1/me/dealership/dossiers/{id}/pieces/{piece}/upload-ticket", method: "post" },
  { path: "/api/v1/me/dealership/dossiers/{id}/pieces/{piece}/confirm", method: "post" },
  { path: "/api/v1/me/capacity-estimate", method: "post" },
  { path: "/api/v1/me/vehicles/{vehicleId}/queue", method: "get" },
  { path: "/api/v1/me/vehicles/{vehicleId}/queue", method: "post" },
  { path: "/api/v1/me/vehicles/{vehicleId}/queue", method: "delete" },
  { path: "/api/v1/me/vehicles/{vehicleId}/interest", method: "get" },
  { path: "/api/v1/me/queue-board", method: "get" },
  { path: "/api/v1/me/vehicles/{vehicleId}/queue/answer", method: "post" },
  { path: "/api/v1/me/dealership/dossiers/{id}", method: "get" },
  { path: "/api/v1/bank/files/{id}/behaviour", method: "get" },
  { path: "/api/v1/bank/files/{id}/questions", method: "get" },
  { path: "/api/v1/bank/files/{id}/questions", method: "post" },
  { path: "/api/v1/bank/files/{id}/underwriting/avis", method: "post" },
  { path: "/api/v1/bank/files/{id}/underwriting/second-look", method: "post" },
  { path: "/api/v1/bank/decisions", method: "get" },
  { path: "/api/v1/bank/decisions/{id}", method: "get" },
  { path: "/api/v1/bank/decisions/{id}", method: "post" },
  { path: "/api/v1/bank/decisions/{id}/preview", method: "post" },
  { path: "/api/v1/bank/decisions/{id}/committee", method: "post" },
  { path: "/api/v1/bank/files/{id}/reassign", method: "get" },
  { path: "/api/v1/bank/files/{id}/reassign", method: "post" },
  { path: "/api/v1/bank/team/{userId}/portfolio/transfer", method: "get" },
  { path: "/api/v1/bank/team/{userId}/portfolio/transfer", method: "post" },
  { path: "/api/v1/bank/team/journal", method: "get" },
  { path: "/api/v1/bank/files/{id}/instructions/{instructionId}/treated", method: "post" },
  { path: "/api/v1/bank/files/{id}/signature-pack", method: "post" },
  { path: "/api/v1/bank/files/{id}/signature-appointment", method: "put" },
  { path: "/api/v1/bank/files/{id}/documents/{docId}/signed", method: "post" },
  { path: "/api/v1/bank/files/{id}/conditions", method: "post" },
  { path: "/api/v1/bank/files/{id}/conditions/{key}/lift", method: "post" },
  { path: "/api/v1/bank/files/{id}/pieces", method: "get" },
  { path: "/api/v1/bank/files/{id}/checks/{checkId}/verdict", method: "post" },
  { path: "/api/v1/bank/files/{id}/reviews/{reviewId}/undo", method: "post" },
  { path: "/api/v1/bank/files/{id}/pieces/{pieceId}/image", method: "get" },
  { path: "/api/v1/bank/files/{id}/pieces/{code}/file", method: "get" },
  { path: "/api/v1/submissions/{id}/offer", method: "post" },
  { path: "/api/v1/submissions/{id}/refusal", method: "post" },
  { path: "/api/v1/admin/flags", method: "get" },
  { path: "/api/v1/admin/flags/diagnostics", method: "get" },
  { path: "/api/v1/admin/flags/{key}", method: "put" },
  { path: "/api/v1/auth/staff/login", method: "post" },
  { path: "/api/v1/auth/refresh", method: "post" },
  { path: "/api/v1/auth/logout", method: "post" },
  { path: "/api/v1/auth/password/reset-request", method: "post" },
  { path: "/api/v1/auth/password/reset-check", method: "post" },
  { path: "/api/v1/auth/password/reset", method: "post" },
  { path: "/api/v1/auth/totp/enroll", method: "post" },
  { path: "/api/v1/auth/totp/verify", method: "post" },
  { path: "/api/v1/auth/totp/recovery/regenerate", method: "post" },
  { path: "/api/v1/me", method: "get" },
  { path: "/api/v1/me", method: "patch" },
  { path: "/api/v1/me/password", method: "post" },
  { path: "/api/v1/me/profile", method: "get" },
  { path: "/api/v1/me/profile", method: "put" },
  { path: "/api/v1/me/notifications", method: "get" },
  { path: "/api/v1/me/notifications/read", method: "post" },
  { path: "/api/v1/me/notifications/{id}/read", method: "post" },
  { path: "/api/v1/me/notifications/unread-count", method: "get" },
  { path: "/api/v1/audit", method: "get" },
  { path: "/api/v1/audit/objects/{type}/{id}", method: "get" },
  { path: "/api/v1/audit/exports", method: "post" },
  { path: "/api/v1/audit/exports/{id}", method: "get" },
  { path: "/api/v1/accounts", method: "get" },
  { path: "/api/v1/accounts/{userId}/deactivate", method: "post" },
  { path: "/api/v1/accounts/{userId}/erase", method: "post" },
  { path: "/api/v1/clients", method: "get" },
  { path: "/api/v1/clients/{id}/deactivate", method: "post" },
  { path: "/api/v1/clients/{id}/reactivate", method: "post" },
  { path: "/api/v1/clients/{id}/erase", method: "post" },
  { path: "/api/v1/users", method: "get" },
  { path: "/api/v1/users", method: "post" },
  { path: "/api/v1/users/{id}/deactivate", method: "post" },
  { path: "/api/v1/users/{id}/portfolio/transfer", method: "post" },
  { path: "/api/v1/users/{id}/deactivation", method: "get" },
  { path: "/api/v1/users/{id}/availability", method: "patch" },
  { path: "/api/v1/users/{id}/delegation", method: "get" },
  { path: "/api/v1/users/{id}/delegation", method: "put" },
  { path: "/api/v1/organisations", method: "get" },
  { path: "/api/v1/organisations", method: "post" },
  { path: "/api/v1/organisations/{id}", method: "get" },
  { path: "/api/v1/organisations/{id}", method: "patch" },
  { path: "/api/v1/organisations/{id}/first-admin", method: "post" },
  { path: "/api/v1/organisations/{id}/admins", method: "post" },
  { path: "/api/v1/organisations/{id}/admins/{userId}/deactivate", method: "post" },
  { path: "/api/v1/invitations/{token}", method: "get" },
  { path: "/api/v1/invitations/{token}/accept", method: "post" },
  { path: "/api/v1/invitations/{id}/resend", method: "post" },
  { path: "/api/v1/invitations/{id}/revoke", method: "post" },
  { path: "/api/v1/partners/{organisationId}/account", method: "get" },
  { path: "/api/v1/partners/breach-settings", method: "get" },
  { path: "/api/v1/partners/breach-settings", method: "post" },
  { path: "/api/v1/partners/{organisationId}/breaches", method: "get" },
  { path: "/api/v1/partners/{organisationId}/breach-claims/{id}/settle", method: "post" },
  { path: "/api/v1/partners/{organisationId}/breach-claims/{id}/waive", method: "post" },
  { path: "/api/v1/partners/{organisationId}/account/address", method: "put" },
  { path: "/api/v1/me/dealership", method: "get" },
  { path: "/api/v1/me/dealership/address", method: "put" },
  { path: "/api/v1/me/dealership/proforma-details", method: "put" },
  { path: "/api/v1/me/dealership/bank-account", method: "get" },
  { path: "/api/v1/me/dealership/bank-account", method: "put" },
  { path: "/api/v1/vehicles/{id}/visits", method: "post" },
  { path: "/api/v1/me/favourites", method: "get" },
  { path: "/api/v1/me/favourites/{vehicleId}", method: "put" },
  { path: "/api/v1/me/favourites/{vehicleId}", method: "delete" },
  { path: "/api/v1/me/passed-vehicles", method: "get" },
  { path: "/api/v1/me/passed-vehicles", method: "delete" },
  { path: "/api/v1/me/passed-vehicles/{vehicleId}", method: "put" },
  { path: "/api/v1/me/passed-vehicles/{vehicleId}", method: "delete" },
  { path: "/api/v1/me/queue-front", method: "get" },
  { path: "/api/v1/me/flags", method: "get" },
  { path: "/api/v1/me/vehicles", method: "get" },
  { path: "/api/v1/me/vehicles/next-reference", method: "get" },
  { path: "/api/v1/me/vehicles/{id}", method: "get" },
  { path: "/api/v1/me/vehicles/{id}", method: "patch" },
  { path: "/api/v1/reference/photo-views", method: "get" },
  { path: "/api/v1/reference/equipment", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/photos", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/photos", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/photos/ticket", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/photos/{photoId}", method: "delete" },
  { path: "/api/v1/me/vehicles/{id}/photos/order", method: "put" },
  { path: "/api/v1/me/vehicles/{id}/documents", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/documents", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/documents/ticket", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/chassis", method: "put" },
  { path: "/api/v1/me/vehicles/{id}/dossier-requests", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/dossier-requests/{dossierId}/proforma/ticket", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/dossier-requests/{dossierId}/proforma", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/dossier-requests/{dossierId}/proforma/issue", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/publish", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/price", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/withdraw", method: "post" },
  { path: "/api/v1/vehicles/{id}/breach", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/relist", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/assignee", method: "post" },
  { path: "/api/v1/reference/vehicle-makes", method: "get" },
  { path: "/api/v1/reference/vehicle-options", method: "get" },
  { path: "/api/v1/feature-requests", method: "get" },
  { path: "/api/v1/feature-requests", method: "post" },
  { path: "/api/v1/feature-requests/{id}/screenshot/ticket", method: "post" },
  { path: "/api/v1/feature-requests/{id}/screenshot", method: "post" },
  { path: "/api/v1/cities", method: "get" },
  { path: "/api/v1/zones", method: "get" },
  { path: "/api/v1/cities/{cityId}/zones", method: "get" },
  { path: "/api/v1/vehicles", method: "get" },
  { path: "/api/v1/vehicles", method: "post" },
  { path: "/api/v1/vehicles/{id}", method: "get" },
  { path: "/api/v1/staff/organisations/{orgId}/vehicles", method: "post" },
  { path: "/api/v1/staff/organisations/{orgId}/vehicles/{id}", method: "patch" },
  { path: "/api/v1/simulations", method: "post" },
  { path: "/api/v1/simulations/{id}", method: "get" },
  { path: "/api/v1/prequalifications", method: "post" },
  { path: "/api/v1/me/prequalification", method: "get" },
  { path: "/api/v1/me/prequalification", method: "delete" },
  { path: "/api/v1/me/prequalification/basis", method: "get" },
  { path: "/api/v1/simulation/quote", method: "post" },
  { path: "/api/v1/simulation/config", method: "get" },
  { path: "/api/v1/simulation/searches", method: "post" },
  { path: "/api/v1/dossiers", method: "get" },
  { path: "/api/v1/dossiers/{id}", method: "get" },
  { path: "/api/v1/dossiers/{id}/journal", method: "get" },
  { path: "/api/v1/dossiers/{id}/dealer-access-facts", method: "get" },
  { path: "/api/v1/auth/client/otp", method: "post" },
  { path: "/api/v1/auth/client/otp/verify", method: "post" },
  { path: "/api/v1/auth/client/register", method: "post" },
  { path: "/api/v1/auth/client/pin", method: "post" },
  { path: "/api/v1/auth/client/pin/login", method: "post" },
  { path: "/api/v1/admin/clients/devices", method: "get" },
  { path: "/api/v1/admin/clients/devices/release", method: "post" },
  { path: "/api/v1/auth/client/devices", method: "get" },
  { path: "/api/v1/auth/client/devices/notices/read", method: "post" },
  { path: "/api/v1/auth/client/devices/{id}", method: "delete" },
  { path: "/api/v1/me/dossiers", method: "get" },
  { path: "/api/v1/me/dossiers", method: "post" },
  { path: "/api/v1/me/dossiers/{id}", method: "get" },
  { path: "/api/v1/me/sellers/{organisationId}/contact", method: "get" },
  { path: "/api/v1/cabinet/tour", method: "get" },
  { path: "/api/v1/cabinet/tour/acknowledge", method: "post" },
  { path: "/api/v1/cabinet/fee", method: "get" },
  { path: "/api/v1/cabinet/demands/{id}/prevented", method: "post" },
  { path: "/api/v1/cabinet/demands/{id}", method: "get" },
  { path: "/api/v1/cabinet/demands/{id}/entry", method: "put" },
  { path: "/api/v1/cabinet/demands/{id}/entry/return", method: "post" },
  { path: "/api/v1/cabinet/demands/{id}/entry/visa", method: "post" },
  { path: "/api/v1/cabinet/entries", method: "get" },
  { path: "/api/v1/documents/{ownerType}/{ownerId}/upload-ticket", method: "post" },
  { path: "/api/v1/documents/{ownerType}/{ownerId}/confirm", method: "post" },
  { path: "/api/v1/documents/{ownerType}/{ownerId}", method: "get" },
  { path: "/api/v1/cabinet/me", method: "get" },
  { path: "/api/v1/cabinet/capacities/{dayId}", method: "put" },
  { path: "/api/v1/cabinet/fees", method: "get" },
  { path: "/api/v1/cabinet/reports", method: "get" },
  { path: "/api/v1/cabinet/reports/{id}/flag", method: "post" },
  { path: "/api/v1/cabinet/demands/{id}/entry/correction", method: "post" },
  { path: "/api/v1/cabinet/reports/{id}/correction/refuse", method: "post" },
  { path: "/api/v1/expertise/requests/{id}/correction-request", method: "post" },
  { path: "/api/v1/dossiers/{id}/rapport", method: "get" },
  { path: "/api/v1/dossiers/{id}/rapport/lecture-hakili", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/rapport", method: "get" },
  { path: "/api/v1/expertise/cabinets/{id}/terms", method: "put" },
  { path: "/api/v1/me/dossiers/{id}/fees/verification", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/fees/verification/cancel", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/fees/verification/declare-paid", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/launch-verification", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/abandon", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/pieces", method: "get" },
  { path: "/api/v1/me/dossiers/{id}/pieces/{piece}/upload-ticket", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/pieces/{piece}/confirm", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/submit-pieces", method: "post" },
  { path: "/api/v1/public/deposit-links/{token}", method: "get" },
  { path: "/api/v1/public/deposit-links/{token}/upload-ticket", method: "post" },
  { path: "/api/v1/public/light-links/{token}", method: "get" },
  { path: "/api/v1/public/light-links/{token}/code", method: "post" },
  { path: "/api/v1/public/light-links/{token}/verify", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/consent", method: "get" },
  { path: "/api/v1/me/dossiers/{id}/consent", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/consent/code", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/consent/withdraw", method: "post" },
  { path: "/api/v1/public/deposit-links/{token}/confirm", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/mandate", method: "get" },
  { path: "/api/v1/me/dossiers/{id}/mandate", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/fees", method: "get" },
  { path: "/api/v1/me/payments/{id}", method: "get" },
  { path: "/api/v1/payments/settings", method: "get" },
  { path: "/api/v1/payments/settings", method: "post" },
  { path: "/api/v1/payments/verification-fees", method: "get" },
  { path: "/api/v1/payments/verification-fees/{id}/confirm-transfer", method: "post" },
  { path: "/api/v1/webhooks/mobile-money/{provider}", method: "post" },
  { path: "/api/v1/me/offers", method: "get" },
  { path: "/api/v1/me/offers/{id}/accept", method: "post" },
  { path: "/api/v1/me/offers/{id}/acceptance-code", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/warranty-settlement", method: "put" },
  { path: "/api/v1/bank/files/{id}/completion-request", method: "post" },
  { path: "/api/v1/submissions/{id}/resubmit", method: "post" },
  { path: "/api/v1/bank/files/{id}/refuse", method: "post" },
  { path: "/api/v1/dossiers/{id}/all-refused", method: "post" },
  { path: "/api/v1/proposed-sends", method: "get" },
  { path: "/api/v1/proposed-sends/{id}/approval", method: "post" },
  { path: "/api/v1/proposed-sends/{id}/dismissal", method: "post" },
  { path: "/api/v1/dossiers/{id}/fees/verification/flag-control", method: "post" },
  { path: "/api/v1/dossiers/{id}/conditions/{cle}/lift", method: "post" },
  { path: "/api/v1/dossiers/{id}/conditions/{cle}/reopen", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces", method: "get" },
  { path: "/api/v1/dossiers/{id}/synthesis", method: "get" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/on-behalf/upload-ticket", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/on-behalf", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/relance", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/relance-vendeur", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/relance-all", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/reject", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/sans-objet", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/sans-objet/undo", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/pieceIdentite/verification", method: "post" },
  { path: "/api/v1/dossiers/{id}/pieces/{piece}/consult", method: "post" },
  { path: "/api/v1/dossiers/{id}/first-pass", method: "get" },
  { path: "/api/v1/dossiers/{id}/first-pass/launch", method: "post" },
  { path: "/api/v1/dossiers/{id}/first-pass/fields/{field}/confirm", method: "post" },
  { path: "/api/v1/dossiers/{id}/first-pass/fields/{field}/correct", method: "post" },
  { path: "/api/v1/dossiers/{id}/first-pass/fields/{field}/manual", method: "post" },
  { path: "/api/v1/dossiers/{id}/underwriting/launch", method: "post" },
  { path: "/api/v1/dossiers/{id}/underwriting", method: "get" },
  { path: "/api/v1/dossiers/{id}/analysis/launch", method: "post" },
  { path: "/api/v1/dossiers/{id}/analysis", method: "get" },
  { path: "/api/v1/dossiers/{id}/submission-options", method: "get" },
  { path: "/api/v1/dossiers/{id}/employment-verification", method: "get" },
  { path: "/api/v1/dossiers/{id}/employment-verification", method: "post" },
  { path: "/api/v1/dossiers/assignable", method: "get" },
  { path: "/api/v1/dossiers/supervision", method: "get" },
  { path: "/api/v1/dossiers/arrivals", method: "get" },
  { path: "/api/v1/dossiers/mark-seen", method: "post" },
  { path: "/api/v1/dossiers/{id}/assignment", method: "post" },
  { path: "/api/v1/team/workload", method: "get" },
  { path: "/api/v1/team/{userId}/portfolio/transfer", method: "get" },
  { path: "/api/v1/team/{userId}/portfolio/transfer", method: "post" },
  { path: "/api/v1/partners/{organisationId}/journal", method: "get" },
  { path: "/api/v1/partners/{organisationId}/journal", method: "post" },
  { path: "/api/v1/partners/signals", method: "get" },
  { path: "/api/v1/partners/pipeline", method: "get" },
  { path: "/api/v1/partners/pipeline/{accountId}/advance", method: "post" },
  { path: "/api/v1/intelligence/supervision", method: "get" },
  { path: "/api/v1/payments/file-fees", method: "get" },
  { path: "/api/v1/me/balance", method: "get" },
  { path: "/api/v1/me/balance/topups", method: "post" },
  { path: "/api/v1/payments/topups", method: "get" },
  { path: "/api/v1/payments/topups/{id}/confirm", method: "post" },
  { path: "/api/v1/payments/fees/{id}/refund-confirm", method: "post" },
  { path: "/api/v1/payments/settlements", method: "get" },
  { path: "/api/v1/payments/settlements/{id}/hakili-leg", method: "post" },
  { path: "/api/v1/me/settlements", method: "get" },
  { path: "/api/v1/me/settlements/{id}/confirm-receipt", method: "post" },
  { path: "/api/v1/me/settlements/{id}/report-non-receipt", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/pickup-voucher", method: "get" },
  { path: "/api/v1/bank/files/{id}/disbursement", method: "get" },
  { path: "/api/v1/bank/files/{id}/disburse", method: "post" },
  { path: "/api/v1/bank/files/{id}/funds", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/handover", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/availability", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/availability", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/rapport", method: "get" },
  { path: "/api/v1/me/attention", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/price-gap", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/price-gap/align", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/price-gap/propose", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/price-gap/maintain", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/price-gap/accept-counter", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/accept-price", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/counter-price", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/cash-settlement", method: "get" },
  { path: "/api/v1/me/dossiers/{id}/cash-settlement", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/cash-settlement/declare", method: "post" },
  { path: "/api/v1/payments/file-fees/{id}/collect", method: "post" },
  { path: "/api/v1/me/dossiers/{id}/file-fee", method: "get" },
  { path: "/api/v1/me/dossiers/{id}/file-fee/declare", method: "post" },
  { path: "/api/v1/partners/{organisationId}/convention", method: "get" },
  { path: "/api/v1/partners/{organisationId}/convention", method: "put" },
  { path: "/api/v1/partners/{organisationId}/manager", method: "put" },
  { path: "/api/v1/payments/file-fees/quote", method: "get" },
  { path: "/api/v1/payments/verification-fees/quote", method: "get" },
  { path: "/api/v1/expertise/days/{id}/cabinets/{cabinetId}/stops/{sellerOrganisationId}/reassign", method: "post" },
  { path: "/api/v1/dossiers/{id}/advance", method: "post" },
  { path: "/api/v1/dossiers/{id}/remettre-en-collecte", method: "post" },
  { path: "/api/v1/dossiers/{id}/close", method: "post" },
  { path: "/api/v1/dossiers/hold-settings", method: "get" },
  { path: "/api/v1/dossiers/hold-settings", method: "post" },
  { path: "/api/v1/dossiers/signals", method: "get" },
  { path: "/api/v1/dossiers/closures/reasons", method: "get" },
  { path: "/api/v1/dossiers/{id}/holds", method: "get" },
  { path: "/api/v1/dossiers/{id}/submissions", method: "get" },
  { path: "/api/v1/dossiers/{id}/submissions", method: "post" },
  { path: "/api/v1/expertise/cabinets", method: "get" },
  { path: "/api/v1/expertise/cabinets", method: "post" },
  { path: "/api/v1/expertise/thursdays", method: "get" },
  { path: "/api/v1/expertise/grid", method: "get" },
  { path: "/api/v1/expertise/requests", method: "get" },
  { path: "/api/v1/catalog/minimum-vehicle-price", method: "get" },
  { path: "/api/v1/catalog/minimum-vehicle-price", method: "post" },
  { path: "/api/v1/catalog/minimum-vehicle-price/below-floor", method: "get" },
  { path: "/api/v1/me/dealership/vehicles/{id}/price-mode", method: "get" },
  { path: "/api/v1/me/dealership/vehicles/{id}/price-mode", method: "put" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers", method: "get" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers/accept-next", method: "post" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers/unavailable", method: "post" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers/{offerId}/accept", method: "post" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers/{offerId}/decline", method: "post" },
  { path: "/api/v1/me/dealership/vehicles/{id}/offers/{offerId}/counter", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/offer", method: "get" },
  { path: "/api/v1/me/vehicles/{id}/offer", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/offer/counter", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/offer/accept", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/offer/decline", method: "post" },
  { path: "/api/v1/me/vehicles/{id}/offer/withdraw", method: "post" },
  { path: "/api/v1/expertise/mileage-tolerance", method: "get" },
  { path: "/api/v1/expertise/mileage-tolerance", method: "post" },
  { path: "/api/v1/expertise/mileage-tolerance/vehicles/{vehicleId}/reuse", method: "get" },
  { path: "/api/v1/expertise/requests/{id}", method: "get" },
  { path: "/api/v1/expertise/requests/{id}/schedule", method: "post" },
  { path: "/api/v1/expertise/requests/{id}/report", method: "post" },
  { path: "/api/v1/expertise/reports/{id}", method: "get" },
  { path: "/api/v1/expertise/thursdays/{id}/composition", method: "get" },
  { path: "/api/v1/expertise/queue", method: "get" },
  { path: "/api/v1/expertise/days", method: "get" },
  { path: "/api/v1/expertise/days/{id}", method: "get" },
  { path: "/api/v1/expertise/days/{id}/cabinets/{cabinetId}/tour-sheet", method: "post" },
  { path: "/api/v1/expertise/settings/arrest", method: "post" },
  { path: "/api/v1/expertise/coverage", method: "get" },
  { path: "/api/v1/public/tour-sheets/{token}", method: "get" },
  { path: "/api/v1/public/tour-sheets/{token}/acknowledge", method: "post" },
] as const;

/** Every path the API publishes. A path outside this union is a compile error. */
export type ApiPath = (typeof OPERATIONS)[number]["path"];

/** Every method the API publishes on any path. */
export type ApiMethod = (typeof OPERATIONS)[number]["method"];

/** The (path, method) pairs that actually exist, as a union of both together. */
export type ApiOperation = (typeof OPERATIONS)[number];

export function isApiOperation(path: string, method: string): boolean {
  return OPERATIONS.some((operation) => operation.path === path && operation.method === method);
}
